import pages from "~/i18n/pages";
import { useT } from "~/i18n/useT";

import "./WhyChoose.scss";

export default function WhyChoose() {
  const t = useT(pages);

  return (
    <section className="ss-section ss-container">
      <div className="ss-panel ss-panel--dark">
        <div
          className="ss-glow ss-glow--blue ss-why__glow"
          aria-hidden="true"
        />

        <div className="ss-why">
          <p className="ss-eyebrow">{t.whyChoose.eyebrow}</p>
          <h2 className="ss-why__title">{t.whyChoose.title}</h2>

          <ul className="ss-why__grid">
            {t.whyChoose.items.map((item) => (
              <li key={item.title} className="ss-why__item">
                <h3 className="ss-why__item-title">{item.title}</h3>
                <p className="ss-why__item-body">{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
